"use client";

import { Hero } from "./hero";
import { WhyJoin } from "./why-join";
import { Culture } from "./culture";
import { Values } from "./values";
import { WhatWeDo } from "./what-we-do";
import { Departments } from "./departments";
import { EngineeringRoles } from "./engineering-roles";
import { AiRoles } from "./ai-roles";
import { StrategyRoles } from "./strategy-roles";
import { CreativeRoles } from "./creative-roles";
import { Benefits } from "./benefits";
import { ProfessionalDevelopment } from "./professional-development";
import { WorkEnvironment } from "./work-environment";
import { Interview } from "./interview";
import { Diversity } from "./diversity";
import { LifeAt } from "./life-at";
import { CareersFaq } from "./faq";
import { CareersCta } from "./cta";

export function CareersPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <WhyJoin />
      </div>
      <Culture />
      <div className="bg-aurora-cyan">
        <Values />
      </div>
      <WhatWeDo />
      <div className="bg-aurora-emerald">
        <Departments />
      </div>
      <EngineeringRoles />
      <div className="bg-aurora-amber">
        <AiRoles />
      </div>
      <StrategyRoles />
      <div className="bg-aurora-purple">
        <CreativeRoles />
      </div>
      <Benefits />
      <div className="bg-aurora-cyan">
        <ProfessionalDevelopment />
      </div>
      <WorkEnvironment />
      <div className="bg-aurora-emerald">
        <Interview />
      </div>
      <Diversity />
      <div className="bg-aurora-amber">
        <LifeAt />
      </div>
      <CareersFaq />
      <CareersCta />
    </>
  );
}
